<div class="card-primary">
  <mat-dialog-content>
    <p style="text-align: center">
      {{ 'case.tasks.confirm-no-registrations' | translate | capitalize }}
    </p>
    <p style="text-align: center">
      {{ 'general.actions.are-you-sure' | translate | capitalize }}
    </p>
    <button mat-raised-button [mat-dialog-close]="false" cdkFocusInitial>
      {{ 'general.words.no' | translate | capitalize }}
    </button>
    <button mat-raised-button style="float: right; margin-bottom: 5px" color="primary" [mat-dialog-close]="true">
      {{ 'general.words.yes' | translate | capitalize }}
    </button>
  </mat-dialog-content>
</div>
